import { CheckCircleOutlined, EditOutlined, InfoCircleOutlined, LeftOutlined, TeamOutlined } from "@ant-design/icons";
import {
  Alert,
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Typography,
  Tag,
  Avatar,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  getLabel,
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { useForm } from "antd/es/form/Form";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { BUSINESS_TYPE, RFQStatus } from "../../util/Constant";
import { Option } from "antd/es/mentions";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import Upload from "../../components/Upload";
import {
  isBuyer,
  isEnquiryPublished,
  isExporter,
  isManufacturerCumExporter,
  isVerifiedFreightEligible,
  showAlert,
} from "../../util/helper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { MY_EXIM_API_RFQ } from "../../appRedux/services/requestQuotationsNetwork";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import { 
  GlobalOutlined,
  ThunderboltOutlined,
  StarOutlined,
  HeartOutlined,
  SafetyOutlined
} from '@ant-design/icons';
import VerifiedFreightTag from "../../components/VerifiedFreightTag";

const { TextArea } = Input;

const shipmentTypes = [
  { label: "FCL (Full Container Load)", value: "fcl" },
  { label: "LCL (Less Container Load)", value: "lcl" },
];

const shipmentModes = [
  { label: "Sea", value: "sea" },
  { label: "Air", value: "air" },
];

const PostFreightRateQuotationsDetails = () => {
  const { id } = useParams();
  const { loading } = useSelector(({ common }) => common);
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hasCloneParam = path.includes("clone");
  let isEdit = !hasCloneParam && isValidElement(id);
  const [form] = useForm();

  const [selectedDestinationCountry, setSelectedDestinationCountry] =
    useState(null);
  const [fileList, setFileList] = useState([{ src: "" }]);
  const authUser = useSelector(({ auth }) => auth.userData);
  const [selectedSourceCountry, setSelectedSourceCountry] = useState(
    isBuyer(authUser) ||
      isExporter(authUser) ||
      isManufacturerCumExporter(authUser)
      ? "India"
      : null
  );
  let isEditDisabled = false;
  const countries = useSelector(({ common }) => common.countries);
  const ports = useSelector(({ common }) => common.ports);
  const [sourcePortsData, setSourcePortsData] = useState(null);
  const [destinationPortsData, setDestinationPortsData] = useState([]);
  const { isMobile } = useGetBreakpoints();
  const [RFQFormStatus, setRFQFormStatus] = useState(null);
  const dispatch = useDispatch();
  const [fullPageLoading, setFullPageLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const getPortCode = (portName) => {
    if(!portName) return "";
    const port = ports.find((p) => p.port === portName);
    return port?.code || "";
  }

    const [sendToAllFreights, setSendToAllFreights] = useState(true);
    const [freightSelectionMode, setFreightSelectionMode] = useState("all"); // "all" or "myfreights"
    const [myFreights, setMyFreights] = useState([]);
    const [loadingMyFreights, setLoadingMyFreights] = useState(false);
    const [selectedFreightIds, setSelectedFreightIds] = useState([]);
    const [showFreightSelectionModal, setShowFreightSelectionModal] = useState(false);

    const [freightSelectionError, setFreightSelectionError] = useState(null);

     const fetchMyFreights = useCallback(async () => {
    if (!isExporter(authUser)) return;
    
    try {
      setLoadingMyFreights(true);
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/users/${authUser?.id}/myfreights`
      );
      const myFreightsData = response.data.data || [];
      setMyFreights(myFreightsData);
      
      // Initially select all freight forwarders
      const allIds = myFreightsData.map(item => item.freightId);
      setSelectedFreightIds(allIds);
    } catch (error) {
      console.error("Error fetching my freights:", error);
      message.error("Failed to load your freight forwarders");
    } finally {
      setLoadingMyFreights(false);
    }
  }, [authUser]);

  useEffect(() => {
    if (isExporter(authUser)) {
      fetchMyFreights();
    }
  }, [authUser, fetchMyFreights]);

  const setDataToForm = useCallback(
    (data) => {
      form.setFieldsValue({
        productName: data?.productName,
        productSpecification: data?.description,
        // sourceCountry: data?.sourceCountry,
        sourcePort: data?.sourcePort,
        // destinationCountry: data?.destinationCountry,
        destinationPort: data?.destinationPort,
        containerType: data.containerType,
        noOfContainers: data.noOfContainers,
        netWeightPerContainer: data.netWeightPerContainer,
        shipmentMode: data?.shipmentMode,
        shipmentType: data?.shipmentType,
        cargoReadinessDate: moment(data?.cargoReadinessDate),
        currency: data?.currency,
        rateindication: data?.rateindication,

        freightSelectionMode: data?.freightSelectionMode || "all",
        selectedFreightIds: data?.selectedFreightIds || [],
        // excludeSendingFreightRates: data?.excludedUserIds || [],
      });

      // setSelectedDestinationCountry(data?.destinationCountry);
      // setSelectedSourceCountry(data?.sourceCountry);


        if (data?.freightSelectionMode) {
        setFreightSelectionMode(data.freightSelectionMode);
      }
      
      if (data?.selectedFreightIds) {
        setSelectedFreightIds(data.selectedFreightIds);
      }

      if (
        data?.productImages?.length < 4 &&
        !isEnquiryPublished(RFQFormStatus)
      ) {
        const images = data?.productImages;
        images.push({ src: "" });
        setFileList([...images]);
      } else if (isArrayNonEmpty(data?.productImages)) {
        setFileList([...data?.productImages]);
      }
    },
    [RFQFormStatus, form]
  );


//   const uniqueCountries = React.useMemo(() => {
//   if (!countries) return [];
  
//   const seen = new Set();
//   return countries.filter(country => {
//     if (!country.country || seen.has(country.country)) return false;
//     seen.add(country.country);
//     return true;
//   });
// }, [countries]);

  useEffect(() => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      MY_EXIM_API_RFQ.getRequestQuotationDetails({ id })
        .then((response) => {
          setDataToForm(response?.data?.data);
          setRFQFormStatus(response?.data?.data?.status);
          dispatch(fetchSuccess());
        })
        .catch((e) => {
          showAlert(e?.message);
          dispatch(fetchSuccess());
        });
    }
  }, [dispatch, id, setDataToForm]);

  const onFinish = async (values, isDraftClick = false) => {
    setFullPageLoading(true);
    try {
      let formData = isDraftClick ? form?.getFieldsValue() : values;
      const targetedBusinessTypes = [
        BUSINESS_TYPE.SHIPPING_LINE,
        BUSINESS_TYPE.FREIGHT_FORWARDER,
        BUSINESS_TYPE.CUSTOMHOUSEAGENTS_FREIGHTFORWARDER,
      ];

      // let selectedUsers = formData?.excludeSendingFreightRates || [];
      // let selectedCompanies = selectedUsers.map(
      //   (id) => userData.find((user) => user.id === id)?.companyName
      // );



        let excludedUserIds = [];
      let excludedCompanyNames = [];
      
      // If user chooses "Only selected freight forwarders", we need to get their myfreights
      if (!sendToAllFreights && isExporter(authUser)) {
        try {
          // Fetch the exporter's selected freight forwarders
          const response = await axiosInstance.get(
            `${BASE_API_CONFIG.baseURL}/users/${authUser?.id}/myfreights`
          );
          const myFreights = response.data.data || [];
          const selectedFreightIds = myFreights.map(f => f.freightId);
          
          // Fetch all freight forwarders to determine who to exclude
          const allFreightsResponse = await axiosInstance.get(
            `${BASE_API_CONFIG.baseURL}/users/all/freight-forwarder`
          );
          const allFreights = allFreightsResponse.data.data?.rows || allFreightsResponse.data.data || [];
          
          // Exclude all freight forwarders EXCEPT the selected ones
          excludedUserIds = allFreights
            .filter(f => !selectedFreightIds.includes(f.id))
            .map(f => f.id);
            
          excludedCompanyNames = allFreights
            .filter(f => !selectedFreightIds.includes(f.id))
            .map(f => f.companyName);
            
        } catch (error) {
          console.error("Error fetching freight data:", error);
          // Fallback: send to all if there's an error
          message.warning("Could not fetch your freight forwarders. Sending to all freight forwarders instead.");
        }
      }

      let data = {
        productName: formData?.productName,
        description: formData?.productSpecification || "",
        // sourceCountry: formData?.sourceCountry || "",
        destinationCountry: formData?.destinationCountry || "",
        destinationPort: formData?.destinationPort || "",
        destinationPortcode: getPortCode(formData?.destinationPort),
        sourcePortcode: getPortCode(formData?.sourcePort),
        isDuplicate: hasCloneParam,
        businessTypeId: authUser?.businessTypeId,
        userId: authUser?.id,
        status: isDraftClick ? RFQStatus?.DRAFT : RFQStatus?.PUBLISHED,
        productImages: [...fileList.filter((file) => file?.src)],
        targetedBusinessType: targetedBusinessTypes,
        containerType: formData?.containerType,
        noOfContainers: formData?.noOfContainers,
        netWeightPerContainer: formData?.netWeightPerContainer,
        sourcePort: formData?.sourcePort,
        paymentTerms: formData?.paymentTerms,
        locationForDelivery: formData?.locationForDelivery,
        shipmentMode: formData?.shipmentMode,
        shipmentType: formData?.shipmentType,
        cargoWeight: formData?.cargoWeight,
        totalCubicMeter: formData?.totalCubicMeter,
        cargoReadinessDate: formData?.cargoReadinessDate,
        currency: formData?.currency,
        rateindication: formData?.rateindication,

        freightSelectionMode: freightSelectionMode,
        selectedFreightIds: freightSelectionMode === "myfreights" ? selectedFreightIds : [],
        // excludedUserIds: selectedUsers,
        // excludedCompanyNames: selectedCompanies,
      };

      await updatedDetailsToNetwork(data);
    } catch (error) {
      message.error("Failed to submit form");
    } finally {
      setFullPageLoading(false); // End loading regardless of success/failure
    }
  };

  const updatedDetailsToNetwork = async (data) => {
    try {
      let url = isEdit
        ? `${BASE_API_CONFIG.baseURL}/enquiries/${id}`
        : `${BASE_API_CONFIG.baseURL}/enquiries`;
      await axiosInstance.post(url, data);
      message.success(
        "Your freight rate quotation has been submitted successfully"
      );
      history.goBack();
    } catch (err) {
      message.error(err.message);
    }
  };

  useEffect(() => {
    const countryId = countries.find(
      (item) => item.country === selectedSourceCountry
    )?.id;

    const uniquePorts = Array.from(
      new Map(
        ports
          .filter((item) => item.countryId === countryId)
          .map((item) => [item.port, item])
      ).values()
    );
    setSourcePortsData(uniquePorts);
  }, [countries, ports, selectedSourceCountry]);

  const handleChangeSourceCountry = (value) => {
    setSelectedSourceCountry(value);
    form.resetFields(["sourcePort"]);
  };




  const uniqueCountries = React.useMemo(() => {
  if (!countries) return [];

  const seen = new Set();
  return countries.filter(country => {
    if (!country.country) return false;

    const normalized = country.country.trim().toLowerCase();
    if (seen.has(normalized)) return false;

    seen.add(normalized);
    return true;
  });
}, [countries]);


  useEffect(() => {
    if (
      selectedDestinationCountry &&
      isArrayNonEmpty(countries) &&
      isArrayNonEmpty(ports)
    ) {
      // Clean and normalize the selected country name
      const cleanSelectedCountry = selectedDestinationCountry
        .trim()
        .toUpperCase();

      // Filter ports by countryName (normalize both for comparison)
      const filteredPorts = ports.filter((item) => {
        if (!item.countryName) return false;

        // Clean and normalize the port's country name
        const portCountry = item.countryName.trim().toUpperCase();
        return portCountry === cleanSelectedCountry;
      });

      setDestinationPortsData(filteredPorts);
      console.log("Filtered destination ports:", filteredPorts);
    } else {
      setDestinationPortsData([]);
    }
  }, [selectedDestinationCountry, countries, ports]);

  const handleChangeDestinationCountry = (value) => {
    setSelectedDestinationCountry(value);
    form.resetFields(["destinationPort"]);
  };

  const validatePortSelection = async (_, value) => {
    const sourcePort = form.getFieldValue("sourcePort");
    if (value === sourcePort) {
      throw new Error("Source Port and Destination Port cannot be the same");
    }
  };

  const paymentTerms = Form.useWatch("paymentTerms", form);
  const shipmentMode = Form.useWatch("shipmentMode", form);
  const shipmentType = Form.useWatch("shipmentType", form);

  const onUpload = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = data.src;
      if (updatedList.length < 4) {
        updatedList.push({ src: "" });
      }
      updatedList[data.index].originalName = data.originalName;
      return [...updatedList];
    });
  };
  const onRemove = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = "";
      return updatedList;
    });
  };


  const handleSelectAllFreights = () => {
    const allIds = myFreights.map(item => item.freightId);
    setSelectedFreightIds(allIds);
  };


  
  const handleFreightSelectionChange = (freightId, checked) => {
    if (checked) {
      setSelectedFreightIds([...selectedFreightIds, freightId]);
    } else {
      setSelectedFreightIds(selectedFreightIds.filter(id => id !== freightId));
    }
  };

    const handleDeselectAllFreights = () => {
    setSelectedFreightIds([]);
  };

  const isAllSelected = selectedFreightIds.length === myFreights.length && myFreights.length > 0;
  const isSomeSelected = selectedFreightIds.length > 0 && selectedFreightIds.length < myFreights.length;

  const uploadComponent = (isDisabled) => {
    return (
      <div className="attachments">
        <div className="sub-header">Attachments</div>
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          {fileList?.length > 0 ? (
            fileList.map((file, index) => (
              <Upload
                key={index}
                isDisabled={isDisabled}
                index={index}
                src={file.src}
                id={index}
                label={
                  isValidString(file?.label) ? file?.label : getLabel(index)
                }
                originalName={file.originalName}
                onUpload={onUpload}
                onRemove={onRemove}
              />
            ))
          ) : (
            <div>No attachments added.</div>
          )}
        </div>
      </div>
    );
  };

  const validateTextArea = (_, value) => {
    if (value && value.length > 1000) {
      return Promise.reject(
        new Error("Product Requirements cannot exceed 1000 characters")
      );
    }
    return Promise.resolve();
  };






 const renderFreightSelectionSection = () => {
  if (!isExporter(authUser)) return null;

 
  // Filter selected freight forwarders from myFreights
  const selectedFreights = myFreights.filter(item => 
    selectedFreightIds.includes(item.freightId)
  );

  return (
    <div style={{ marginTop: 24, marginBottom: 16 }}>
      <Divider orientation="left">
        <TeamOutlined style={{ marginRight: 8 }} />
        Freight Forwarder Selection
      </Divider>
      
      <Alert
        message="Choose who should receive this freight enquiry"
        description="Select either all freight forwarders or choose specific ones from your list"
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            label="Send enquiry to:"
            name="freightSelectionMode"
            initialValue="all"
          >
            <Radio.Group 
              value={freightSelectionMode}
              onChange={(e) => setFreightSelectionMode(e.target.value)}
              style={{ width: '100%' }}
            >
              {/* OPTION 1: ALL FREIGHT FORWARDERS */}
              <div 
                style={{ 
                  marginBottom: 16,
                  padding: '16px',
                  border: `2px solid ${freightSelectionMode === 'all' ? '#52c41a' : '#f0f0f0'}`,
                  borderRadius: '8px',
                  backgroundColor: freightSelectionMode === 'all' ? '#f6ffed' : '#fafafa',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onClick={() => setFreightSelectionMode('all')}
              >
                <Radio value="all" style={{ display: 'none' }} />
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  {/* Icon */}
                  <div style={{
                    flexShrink: 0,
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: freightSelectionMode === 'all' ? '#52c41a' : '#e8e8e8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '18px'
                  }}>
                    {freightSelectionMode === 'all' ? <CheckCircleOutlined /> : <GlobalOutlined />}
                  </div>
                  
                  {/* Content */}
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <Typography.Text strong style={{ fontSize: '16px', color: '#262626' }}>
                        All Freight Forwarders Registered With MyEximBusiness
                      </Typography.Text>
                      {freightSelectionMode === 'all' && (
                        <Tag color="success" style={{ margin: 0, fontSize: '12px' }}>Selected</Tag>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* OPTION 2: MY FREIGHT FORWARDERS */}
              <div 
                style={{ 
                  padding: '16px',
                  border: `2px solid ${freightSelectionMode === 'myfreights' ? '#1890ff' : '#f0f0f0'}`,
                  borderRadius: '8px',
                  backgroundColor: freightSelectionMode === 'myfreights' ? '#e6f7ff' : '#fafafa',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onClick={() => setFreightSelectionMode('myfreights')}
              >
                <Radio value="myfreights" style={{ display: 'none' }} />
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  {/* Icon */}
                  <div style={{
                    flexShrink: 0,
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: freightSelectionMode === 'myfreights' ? '#1890ff' : '#e8e8e8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '18px'
                  }}>
                    {freightSelectionMode === 'myfreights' ? <CheckCircleOutlined /> : <TeamOutlined />}
                  </div>
                  
                  {/* Content */}
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <Typography.Text strong style={{ fontSize: '16px', color: '#262626' }}>
                        My Freight Forwarders
                      </Typography.Text>
                      {freightSelectionMode === 'myfreights' && (
                        <Tag color="processing" style={{ margin: 0, fontSize: '12px' }}>Selected</Tag>
                      )}
                    </div>
                  
                    {/* Selected Partners Info */}
                    {freightSelectionMode === 'myfreights' && selectedFreightIds?.length > 0 && (
                      <div style={{ 
                        marginTop: 12,
                        padding: '8px 12px',
                        backgroundColor: 'rgba(24, 144, 255, 0.05)',
                        border: '1px dashed #91d5ff',
                        borderRadius: '6px'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <Badge count={selectedFreightIds.length} style={{ backgroundColor: '#1890ff' }} />
                          <Typography.Text type="secondary" style={{ fontSize: '13px' }}>
                            {selectedFreightIds.length} partner{selectedFreightIds.length !== 1 ? 's' : ''} selected
                          </Typography.Text>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      {freightSelectionMode === "myfreights" && (
        <>
          {loadingMyFreights ? (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <Spin />
              <Typography.Text type="secondary">Loading your freight forwarders...</Typography.Text>
            </div>
          ) : myFreights.length === 0 ? (
            <Alert
              message="No freight forwarders in your list"
              description={
                <div>
                  <Typography.Text type="secondary">
                    You haven't added any freight forwarders to your list yet.
                  </Typography.Text>
                  <Button 
                    type="link" 
                    size="small" 
                    onClick={() => history.push('/my-profile/edit')}
                    style={{ padding: 0, height: 'auto' }}
                  >
                    Go to profile to add freight forwarders
                  </Button>
                </div>
              }
              type="warning"
              showIcon
              style={{ marginBottom: 16 }}
            />
          ) : (
            <div style={{ 
              padding: 16, 
              backgroundColor: '#fafafa', 
              border: '1px solid #d9d9d9',
              borderRadius: 6,
              marginBottom: 16
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <Typography.Text strong>
                    <TeamOutlined style={{ marginRight: 8 }} />
                    My Freight Forwarders
                  </Typography.Text>
                  <Badge 
                    count={selectedFreightIds.length} 
                    style={{ 
                      backgroundColor: selectedFreightIds.length === myFreights.length ? '#52c41a' : '#1890ff',
                      marginLeft: 8 
                    }}
                  />
                </div>
                
               <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
  <Button
    type="link"
    size="middle"
    onClick={() => setShowFreightSelectionModal(true)}
    icon={<EditOutlined />}
    style={{
      padding: '0 12px',
      height: 32,
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      color: selectedFreightIds.length > 0 ? '#1890ff' : '#8c8c8c'
    }}
  >
    {selectedFreightIds.length === 0 
      ? 'Choose Forwarders'
      : 'Edit Selection'
    }
  </Button>
  
  <Badge 
    count={selectedFreightIds.length} 
    overflowCount={99}
    style={{ 
      backgroundColor: selectedFreightIds.length === myFreights.length 
        ? '#52c41a' 
        : '#1890ff',
      fontSize: '10px',
      fontWeight: 'bold',
      boxShadow: '0 0 0 1px #fff'
    }}
  />
  
  <span style={{ 
    fontSize: '12px', 
    color: '#666',
    marginLeft: -4 
  }}>
    of {myFreights.length}
  </span>
</div>
              </div>
              
              {/* CHANGED HERE: Display only selected freight forwarders, not all */}
              {selectedFreights.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 12 }}>
                  <Typography.Text type="secondary">
                    No freight forwarders selected. Click "Select/Deselect" to choose from your list.
                  </Typography.Text>
                </div>
              ) : (
                <div style={{ maxHeight: 150, overflowY: 'auto' }}>
                  <List
                    size="small"
                    dataSource={selectedFreights.slice(0, 3)} 
                    renderItem={(item) => {
                      const freightData = item.freight || {
                        companyName: item.freightCompanyName,
                        verifiedFreight: item.verifiedFreight,
                      };
                      
                      return (
                        <List.Item style={{ 
                          padding: '6px 0', 
                          borderBottom: '1px solid #f0f0f0',
                          backgroundColor: '#f6ffed' // Always green since they're selected
                        }}>
                          <List.Item.Meta
                            avatar={
                              <Avatar 
                                size="small" 
                                style={{ 
                                  backgroundColor: '#52c41a',
                                  color: 'white'
                                }}
                              >
                                {freightData.companyName?.charAt(0)?.toUpperCase() || 'F'}
                              </Avatar>
                            }
                            title={
                              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                <Typography.Text 
                                  style={{ 
                                    fontSize: '12px',
                                    color: '#52c41a'
                                  }}
                                >
                                  {freightData.companyName || 'Unknown'}
                                </Typography.Text>
                                {isVerifiedFreightEligible(freightData) && (
                                  <VerifiedFreightTag verifiedFreight={freightData?.verifiedFreight} />
                                )}
                              </div>
                            }
                          />
                          <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '12px' }} />
                        </List.Item>
                      );
                    }}
                  />
                  
                  {selectedFreights.length > 3 && (
                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                      <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
                        + {selectedFreights.length - 3} more selected forwarders
                      </Typography.Text>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}

      {/* Modal for selecting freight forwarders */}
     <Modal
        title={
         <div style={{
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  paddingBottom: 16,
  borderBottom: '1px solid #f0f0f0',
  marginBottom: 20
}}>
  {/* Title Row */}
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <TeamOutlined style={{ fontSize: '20px', color: '#1890ff' }} />
      <span style={{ fontSize: '18px', fontWeight: 600, color: '#262626' }}>
        Freight Forwarder Selection
      </span>
    </div>
    
    <div style={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: 8,
      backgroundColor: '#fafafa',
      padding: '6px 12px',
      borderRadius: 6,
      border: '1px solid #f0f0f0'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <div style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: selectedFreightIds.length > 0 ? '#52c41a' : '#ff4d4f'
        }} />
        <span style={{ 
          fontSize: '13px', 
          fontWeight: 500, 
          color: selectedFreightIds.length > 0 ? '#595959' : '#ff4d4f'
        }}>
          {selectedFreightIds.length} selected
        </span>
      </div>
      <div style={{ width: 1, height: 16, backgroundColor: '#e8e8e8' }} />
      <span style={{ fontSize: '13px', color: '#8c8c8c' }}>
        Total: {myFreights.length}
      </span>
    </div>
  </div>
  
  {/* Subtitle and Actions Row */}
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div style={{ fontSize: '14px', color: '#595959' }}>
      Select which freight forwarders should receive this enquiry
      {selectedFreightIds.length === 0 && (
        <span style={{ color: '#ff4d4f', marginLeft: 8 }}>
          (At least one selection required)
        </span>
      )}
    </div>
    
    <div style={{ display: 'flex', gap: 8 }}>
      <Button
        type="default"
        size="small"
        onClick={handleSelectAllFreights}
        disabled={isAllSelected}
        style={{
          padding: '0 12px',
          height: 28,
          fontSize: '13px',
          borderRadius: 4,
          border: `1px solid ${isAllSelected ? '#b7eb8f' : '#d9d9d9'}`,
          color: isAllSelected ? '#52c41a' : '#262626',
          backgroundColor: isAllSelected ? '#f6ffed' : 'white'
        }}
      >
        {isAllSelected ? '✓ All Selected' : 'Select All'}
      </Button>
      <Button
        type="default"
        size="small"
        onClick={handleDeselectAllFreights}
        disabled={selectedFreightIds.length === 0}
        style={{
          padding: '0 12px',
          height: 28,
          fontSize: '13px',
          borderRadius: 4,
          border: `1px solid ${selectedFreightIds.length === 0 ? '#f5f5f5' : '#ffccc7'}`,
          color: selectedFreightIds.length === 0 ? '#d9d9d9' : '#ff4d4f',
          backgroundColor: selectedFreightIds.length === 0 ? '#fafafa' : '#fff2f0'
        }}
      >
        Clear All
      </Button>
    </div>
  </div>
</div>
        }
        open={showFreightSelectionModal}
        onCancel={() => {
          // Validate before closing modal
          if (freightSelectionMode === "myfreights" && selectedFreightIds.length === 0) {
            message.warning("Please select at least one freight forwarder");
          } else {
            setShowFreightSelectionModal(false);
          }
        }}
        onOk={() => {
          // Validate before closing modal
          if (freightSelectionMode === "myfreights" && selectedFreightIds.length === 0) {
            message.error("Please select at least one freight forwarder");
          } else {
            setShowFreightSelectionModal(false);
            setFreightSelectionError(null);
          }
        }}
        width={500}
        okText="Done"
        cancelText="Cancel"
      >
        {loadingMyFreights ? (
          <div style={{ textAlign: 'center', padding: 20 }}>
            <Spin />
            <Typography.Text type="secondary">Loading freight forwarders...</Typography.Text>
          </div>
        ) : (
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            <List
              dataSource={myFreights}
              renderItem={(item) => {
                const freightData = item.freight || {
                  companyName: item.freightCompanyName,
                  email: item.freightEmail,
                  mobile: item.freightMobile,
                  city: item.freightCity,
                  country: item.freightCountry,
                  verifiedFreight: item.verifiedFreight,
                };
                const isSelected = selectedFreightIds.includes(item.freightId);
                
                return (
                  <List.Item 
                    style={{ 
                      padding: '12px 0',
                      borderBottom: '1px solid #f0f0f0',
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#f6ffed' : 'transparent'
                    }}
                    onClick={() => handleFreightSelectionChange(item.freightId, !isSelected)}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Checkbox 
                        checked={isSelected}
                        onChange={(e) => handleFreightSelectionChange(item.freightId, e.target.checked)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      
                      <Avatar 
                        size="large" 
                        style={{ 
                          backgroundColor: isSelected ? '#52c41a' : '#1890ff',
                          color: 'white',
                          marginLeft: 12,
                          marginRight: 12
                        }}
                      >
                        {freightData.companyName?.charAt(0)?.toUpperCase() || 'F'}
                      </Avatar>
                      
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                          <Typography.Text strong style={{ display: 'block' }}>
                            {freightData.companyName || 'Unknown'}
                          </Typography.Text>
                          {isVerifiedFreightEligible(freightData) && (
                            <VerifiedFreightTag verifiedFreight={freightData?.verifiedFreight} />
                          )}
                        </div>
                        
                        <div style={{ marginTop: 4 }}>
                          {freightData.email && (
                            <Typography.Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>
                              ✉️ {freightData.email}
                            </Typography.Text>
                          )}
                          <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
                            📍 {freightData.city && `${freightData.city}, `}{freightData.country || 'N/A'}
                          </Typography.Text>
                        </div>
                        
                        {item.notes && (
                          <div style={{ 
                            marginTop: 4,
                            padding: '2px 6px',
                            backgroundColor: '#fffbe6',
                            borderRadius: 3,
                          }}>
                            <Typography.Text type="secondary" style={{ fontSize: '10px' }}>
                              💡 {item.notes}
                            </Typography.Text>
                          </div>
                        )}
                      </div>
                      
                      {isSelected && (
                        <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
                      )}
                    </div>
                  </List.Item>
                );
              }}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

  // const getUsersListAPICall = async () => {
  //   const response = await axiosInstance.get(
  //     `${BASE_API_CONFIG.baseURL}/users/all/freight-forwarder`
  //   );
  //   setUserData(response?.data?.data?.rows || []);
  //   dispatch(fetchSuccess());
  // };

  // useEffect(() => {
  //   dispatch(fetchStart());
  //   getUsersListAPICall();
  // }, [dispatch]);

  return (
    !loading && (
      <div style={{ position: "relative" }}>
        {/* Overlay spinner */}
        {fullPageLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <LoadingOutlined style={{ fontSize: 40, color: "#1890ff" }} spin />
          </div>
        )}
        <Card className="myexim-detail-card">
          <div className="myexim-table-title">
            <LeftOutlined
              // className={"back-icon"}
              style={{ fontSize: "20px", color: "#434E5B" }}
              size="large"
              onClick={() => history.goBack()}
            />
            {isEnquiryPublished(RFQFormStatus) && !hasCloneParam
              ? "Freight Rate Details"
              : isEdit
              ? "Edit Freight Rate"
              : "Get Freight Rate"}
          </div>

          <div style={{ position: "relative" }}>
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,

                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 999,
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    border: "4px solid #f3f3f3",
                    borderTop: "4px solid #1890ff",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
                {/* <Spin size="large" /> */}
              </div>
            )}

            <Form
              form={form}
              onFinish={onFinish}
              initialValues={{ currency: "USD", sourceCountry: "India" }}
              className="gx-pt-4"
            >
              <Row gutter={16}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Product Name"
                    name="productName"
                    rules={[
                      { required: true, message: "Product name is required" },
                    ]}
                  >
                    <Input
                      disabled={isEditDisabled}
                      placeholder="Enter service name"
                      size="large"
                      showCount
                      maxLength={100}
                    />
                  </Form.Item>
                </Col>

                {/* <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Loading Country"
                name="sourceCountry"
                rules={[
                  { required: true, message: "Loading country is required" },
                ]}
              >
                <Select
                  defaultValue={
                    isBuyer(authUser) ||
                    isExporter(authUser) ||
                    isManufacturerCumExporter(authUser)
                      ? "India"
                      : null
                  }
                  disabled={
                    isEditDisabled ||
                    isBuyer(authUser) ||
                    isExporter(authUser) ||
                    isManufacturerCumExporter(authUser)
                  }
                  showSearch
                  size="large"
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={handleChangeSourceCountry}
                  value={selectedSourceCountry}
                  placeholder="Select Loading Country"
                >
                  {countries?.map(
                    (option) =>
                      option.country !== "" && (
                        <Option key={option.country} value={option.country}>
                          {option.country}
                        </Option>
                      )
                  )}
                </Select>
              </Form.Item>
            </Col> */}

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Loading Port(India)"
                    name="sourcePort"
                    rules={[
                      { required: true, message: "Loading port is required" },
                    ]}
                  >
                    <Select
                      showSearch
                      virtual={false}
                      size="large"
                      placeholder="Select Loading Port"
                      disabled={!selectedSourceCountry}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {isValidElement(sourcePortsData)
                        ? sourcePortsData?.map((option) => (
                            <Option key={option.port} value={option.port}>
                              {`${option.port} (${option.code})`}
                            </Option>
                          ))
                        : ports?.map((option) => (
                            <Option key={option.port} value={option.port}>
                              {`${option.port} (${option.code})`}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Destination Country"
                    name="destinationCountry"
                    rules={[
                      {
                        required: true,
                        message: "Destination country is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      size="large"
                      placeholder="Select Destination Country"
                      onChange={handleChangeDestinationCountry}
                      value={selectedDestinationCountry}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {countries?.map((option) => (
                        <Option key={option.country} value={option.country}>
                          {option.country}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Col> */}

          <Col xs={24} sm={12} md={12}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Destination Country"
                          name="destinationCountry"
                          rules={[
                            {
                              required: true,
                              message: "Destination country is required",
                            },
                          ]}
                        >
                          <Select
          showSearch
          size="large"
          placeholder="Select Destination Country"
          onChange={handleChangeDestinationCountry}
          value={selectedDestinationCountry}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          {uniqueCountries.map((option) => (
    <Option key={option.country} value={option.country}>
      {option.country}
    </Option>
  ))}
        </Select>
                        </Form.Item>
                      </Col>
          


                {/* <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Destination Port"
                name="destinationPort"
                rules={[
                  { required: true, message: "Destination port is required" },
                  { validator: validatePortSelection },
                ]}
              >
                <Select
                  showSearch
                  size="large"
                  placeholder="Select Destination Port"
                  // disabled={!selectedDestinationCountry}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {isValidElement(destinationPortsData)
                    ? destinationPortsData?.map((option) => (
                        <Option key={option.port} value={option.port}>
                          {`${option.port}(${option.code})`}
                        </Option>
                      ))
                    : ports?.map((option) => (
                        <Option key={option.port} value={option.port}>
                          {`${option.port}(${option.code})`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Col> */}

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Destination Port"
                    name="destinationPort"
                    rules={[
                      {
                        required: true,
                        message: "Destination port is required",
                      },
                      { validator: validatePortSelection },
                    ]}
                  >
                    <Select
                      showSearch
                      size="large"
                      placeholder="Select Destination Port"
                      disabled={!selectedDestinationCountry}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {destinationPortsData.map((option) => (
                        <Option key={option.port} value={option.port}>
                          {`${option.port} (${option.code})`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Shipment Mode"
                    name="shipmentMode"
                    rules={[
                      { required: true, message: "Shipment mode is required" },
                    ]}
                  >
                    <Radio.Group
                      options={shipmentModes}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </Form.Item>
                </Col>

                {shipmentMode === "sea" && (
                  <Col span={24}>
                    <Form.Item
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      label="Shipment Type"
                      name="shipmentType"
                      rules={[
                        {
                          required: true,
                          message: "Shipment type is required",
                        },
                      ]}
                    >
                      <Radio.Group
                        options={shipmentTypes}
                        optionType="button"
                        buttonStyle="solid"
                      />
                    </Form.Item>
                  </Col>
                )}

                {(shipmentMode === "air" || shipmentType === "lcl") && (
                  <>
                    <Col xs={24} sm={12} md={12}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Cargo Weight (In Kilograms)"
                        name="cargoWeight"
                        rules={[
                          {
                            required: true,
                            message: "Cargo weight is required",
                          },
                        ]}
                      >
                        <Input
                          disabled={isEditDisabled}
                          placeholder="Cargo Weight"
                          size="large"
                          type="number"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={12}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Total Cubic Meters (m^3)"
                        name="totalCubicMeter"
                        rules={[
                          { required: true, message: "Volume is required" },
                        ]}
                      >
                        <Input
                          disabled={isEditDisabled}
                          placeholder="Total Volume"
                          size="large"
                          type="number"
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}

                {shipmentMode === "sea" && shipmentType === "fcl" && (
                  <>
                    <Col xs={24} sm={12} md={12}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Container Type"
                        name="containerType"
                        rules={[
                          {
                            required: true,
                            message: "Container type is required",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          size="large"
                          placeholder="Select Container type"
                          getPopupContainer={(trigger) => trigger.parentNode}
                        >
                          <Option value="20drystandard">
                            20' Dry Standard
                          </Option>
                          <Option value="40drystandard">
                            40' Dry Standard
                          </Option>
                          <Option value="40dryhighcube">
                            40' Dry High Cube
                          </Option>
                          <Option value="45dryhighcube">
                            45' Dry High Cube
                          </Option>
                          <Option value="20reefer">20' Reefer</Option>
                          <Option value="40reeferhighcube">
                            40' Reefer High Cube
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={12}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="No. of Containers"
                        name="noOfContainers"
                        rules={[
                          {
                            required: true,
                            message: "Number of containers is required",
                          },
                        ]}
                      >
                        <InputNumber min={1} style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={12}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Net Weight Per Container (Kilograms)"
                        name="netWeightPerContainer"
                        rules={[
                          { required: true, message: "Net weight is required" },
                        ]}
                      >
                        <InputNumber min={0} style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>

              <Row>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Rate Indication"
                    required={false}
                  >
                    <Input.Group compact>
                      <div style={{ display: "flex", width: "100%" }}>
                        <Form.Item
                          name="currency"
                          noStyle
                          rules={[
                            { required: true, message: "Currency is required" },
                          ]}
                        >
                          <Select
                            showSearch
                            size="large"
                            placeholder="Select Currency"
                            defaultValue="USD"
                            style={{ width: "30%" }}
                          >
                            {countries
                              ?.filter(
                                (country, index) =>
                                  index ===
                                  countries.findIndex(
                                    (o) =>
                                      country.currencyCode === o.currencyCode
                                  )
                              )
                              .map(
                                (option) =>
                                  option.currencyCode && (
                                    <Option
                                      key={option.id}
                                      value={option.currencyCode}
                                    >
                                      {option.currencyCode}
                                    </Option>
                                  )
                              )}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name="rateindication"
                          noStyle
                          rules={[{ required: false }]}
                        >
                          <Input
                            type="number"
                            defaultValue={0}
                            min={0}
                            placeholder="Enter Price"
                            size="large"
                            style={{ width: "70%" }}
                          />
                        </Form.Item>
                      </div>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Cargo Readiness Date"
                    name="cargoReadinessDate"
                    rules={[
                      {
                        required: true,
                        message: "Cargo readiness date is required",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      format="DD-MM-YYYY"
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabledDate={(currentDate) => {
                        const cargoReadinessDate =
                          form.getFieldValue("cargoReadinessDate");
                        return (
                          currentDate &&
                          currentDate.isBefore(cargoReadinessDate)
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                {/* <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 12 }}
                    wrapperCol={{ span: 12 }}
                    name="attachment"
                  >
                    {uploadComponent(isEdit)}
                  </Form.Item>
                  <Col>
                    <div className="upload-tips gx-mt-4">
                      <div className="header" style={{ display: "flex" }}>
                        <InfoCircleOutlined />
                        &nbsp; Tips
                      </div>
                      <div className="desc">
                        <Badge
                          status="default"
                          text="Attach supporting documents if needed"
                        />
                        <br />
                        <Badge
                          status="default"
                          text="Supported file types: .jpg, .jpeg, .png, .pdf"
                        />
                        <br />
                        <Badge
                          status="default"
                          text="File must not exceed 5MB"
                        />
                      </div>
                    </div>
                  </Col>
                </Col> */}

                <Col span={24}>
                  <Form.Item
                    disabled={isEditDisabled}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Requirements"
                    name="productSpecification"
                    rules={[
                      { validator: validateTextArea },
                      { required: true, message: "Requirements are required" },
                    ]}
                  >
                    <TextArea
                      rows={10}
                      placeholder="Provide any additional requirements or special instructions"
                      showCount
                      maxLength={1000}
                      disabled={isEditDisabled}
                    />
                  </Form.Item>
                </Col>

                {/* <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Exclude companies from sending freight rates"
                    name="excludeSendingFreightRates"
                  >
                    <Select
                      showSearch
                      mode="multiple"
                      size="large"
                      placeholder="Select companies to exclude"
                      getPopupContainer={(trigger) => trigger.parentNode}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {userData.map((user) => (
                        <Select.Option key={user.id} value={user.id}>
                          {user.companyName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> */}
              </Row>


              {renderFreightSelectionSection()}


              {/* Row 5 */}
              <Row className="gx-pt-5">
                <Col span={24}>
                  <Form.Item className="gx-text-center">
                    <div
                      className="gx-mr-3"
                      style={{
                        justifyContent: isMobile ? "center" : "end",
                        display: "flex",
                        flex: 1,
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      <Button
                        type="secondary"
                        size="large"
                        style={{ width: 200, marginRight: isMobile ? 0 : "" }}
                        onClick={() => history.goBack()}
                      >
                        Cancel
                      </Button>
                      {!isEditDisabled &&
                        RFQFormStatus !== RFQStatus.PENDING_APPROVAL && (
                          <Button
                            type="secondary"
                            size="large"
                            style={{
                              width: 200,
                              marginRight: isMobile ? 0 : "",
                            }}
                            onClick={() => onFinish(form, true)}
                          >
                            Save as draft
                          </Button>
                        )}
                      {!isEditDisabled && (
                        <Button
                          type="primary"
                          size="large"
                          htmlType="submit"
                          style={{ width: 200 }}
                          disabled={fullPageLoading}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Card>
      </div>
    )
  );
};

export default PostFreightRateQuotationsDetails;
